import { Component } from "react";
import { Redirect, withRouter } from "react-router-dom";

// Redux
import { connect } from "react-redux";
import { getAggregators } from "../../redux/actions/aggregators";
import { getAllTransactions } from "./../../redux/actions/transactions";
import { getInvestments } from "../../redux/actions/investments";
import { setToast } from "./../../redux/actions/toast";
import { showModal } from "./../../redux/actions/modal";
// User Dashboards
import PowerBiDashboard from "../PowerBiDasboard/PowerBiDashboard";

// Styles
import "./Dashboard.css";

export class Dashboard extends Component {
  // Methods
  showModalHandler = (modalOptions) => {
    this.props.showModal(modalOptions);
  };

  handleGenerateReport = () => {
    // Get and display the modal
    document.querySelector("#displayModal").style.display = "block";
  };

  // Life Cycle Hooks
  componentDidMount() {
    if (!this.props.isAuthenticated) {
      this.props.history.push("/");
    }
  }

  render() {
    if (!this.props.isAuthenticated) {
      return <Redirect to="/" />;
    } else {
      const { loggedInUser } = this.props;
      const { roleTypes } = loggedInUser;
      return (
        <div className="Dashboard">
          <PowerBiDashboard />
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  const { isAuthenticated, loggedInUser } = state.authReducer;

  return {
    isAuthenticated,
    loggedInUser,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    getAggregators,
    getAllTransactions,
    getInvestments,
    setToast,
    showModal,
  })(Dashboard)
);
